import { FC } from "react";
import { Flex, RadioGroup } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapper } from "~/components";
import { RadioInput, RadioOption } from "./RadioInput";

interface Props {
  Component?: FC<any>;
  gap?: number;
  labelProps?: Record<string, unknown>;
  name: string;
  options: RadioOption[];
  w?: string;
}

export const RadioGroupInput: FC<Props> = ({
  Component = RadioInput,
  gap = 4,
  labelProps,
  options,
  w,
  ...props
}) => {
  const [field, meta] = useField(props as any);
  const type = "radio-group";
  const inputId = `${type}-input-${props.name}`;
  const { onChange, ...rest } = field;

  return (
    <InputWrapper id={inputId} meta={meta} type={type} minH="unset" {...props}>
      <RadioGroup {...rest} w={w}>
        <Flex direction="column" gap={gap} w={w}>
          {options.map((option) => (
            <Component
              key={option.value}
              onChange={onChange}
              {...{ labelProps: labelProps }}
              {...option}
            />
          ))}
        </Flex>
      </RadioGroup>
    </InputWrapper>
  );
};
